import { render, staticRenderFns } from "./DeviceGroupTags.vue?vue&type=template&id=51034672&scoped=true"
import script from "./DeviceGroupTags.vue?vue&type=script&lang=js"
export * from "./DeviceGroupTags.vue?vue&type=script&lang=js"
import style0 from "./DeviceGroupTags.vue?vue&type=style&index=0&id=51034672&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51034672",
  null
  
)

export default component.exports